import { MouseClickRightSvg } from "@lhd/assets";
import { Worker } from "@lhd/types";
import moment from "moment";

export const INSURANCE_OPTIONS = [
  {
    label: "喪失",
    value: "false",
  },
  {
    label: "取得",
    value: "true",
  },
];

export const INHABITANT_TAX_TYPE = [
  {
    label: "普通徴収",
    value: "tax_normal",
  },
  {
    label: "特別徴収",
    value: "tax_special",
  },
];

export const NUM_CHILDREN_OPTIONS = [
  {
    label: "甲0人",
    value: "0",
  },
  {
    label: "甲1人",
    value: "1",
  },
  {
    label: "甲2人",
    value: "2",
  },
  {
    label: "甲3人",
    value: "3",
  },
  {
    label: "甲4人",
    value: "4",
  },
  {
    label: "甲5人",
    value: "5",
  },
  {
    label: "甲6人",
    value: "6",
  },
  {
    label: "甲7人",
    value: "7",
  },
  {
    label: "乙",
    value: "8",
  },
];

export const SALARY_OPTIONS = [
  "58000",
  "68000",
  "78000",
  "88000",
  "98000",
  "104000",
  "110000",
  "118000",
  "126000",
  "134000",
  "142000",
  "150000",
  "160000",
  "170000",
  "180000",
  "190000",
  "200000",
  "220000",
  "240000",
  "260000",
  "280000",
  "300000",
  "320000",
  "340000",
  "360000",
  "380000",
  "410000",
  "440000",
  "470000",
  "500000",
  "530000",
  "560000",
  "590000",
  "620000",
  "650000",
  "680000",
  "710000",
  "750000",
  "790000",
  "830000",
  "880000",
  "930000",
  "980000",
  "1030000",
  "1090000",
  "1150000",
  "1210000",
  "1270000",
  "1330000",
  "1390000",
].map((item) => ({
  label: item,
  value: item,
}));

export const MONTHLY = [12, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];
export const FIELD_MONTH = [
  "salary_",
  "insurance_existence_last_",
  "num_children_",
  "inhabitant_tax_",
];

export const monthlySalary = (size?: any) => {
  return MONTHLY.map((item) => ({
    columnId: `salary_${item}_month`,
    label: `${item}月`,
    type: "numberCurrency",
    width: 120,
    icon: <MouseClickRightSvg size={size} />,
  }));
};

export const monthlyInsurance = (size?: any) => {
  return MONTHLY.map((item) => ({
    columnId: `insurance_existence_last_${item}_month`,
    label: `${item}月`,
    type: "text",
    width: 120,
    icon: <MouseClickRightSvg size={size} />,
  }));
};

export const monthlyNum = (size?: any) => {
  return MONTHLY.map((item) => ({
    columnId: `num_children_${item}_month`,
    label: `${item}月`,
    type: "text",
    width: 120,
    icon: <MouseClickRightSvg size={size} />,
  }));
};

export const monthlyInhabitant = MONTHLY.map((item) => ({
  columnId: `inhabitant_tax_${item}_month`,
  label: `${item}月`,
  type: "numberCurrency",
  width: 120,
  icon: <></>,
}));

export const useColumns = (size?: any) => {
  return [
    {
      columnId: "index",
      label: "",
      type: "text",
      width: 40,
      editTable: true,
      icon: <></>,
    },
    {
      columnId: "worker_no",
      label: "スタッフ番号",
      type: "text",
      width: 100,
      icon: <></>,
      editTable: true,
    },
    {
      columnId: "name",
      label: "氏名",
      type: "text",
      width: 100,
      icon: <></>,
      editTable: true,
    },
    {
      columnId: "is_working",
      label: "現職/退職",
      type: "text",
      width: 100,
      icon: <></>,
      editTable: true,
    },

    //Salary
    {
      columnId: "salary_last_year",
      label: "昨年以前",
      type: "numberCurrency",
      width: 120,
      icon: <MouseClickRightSvg size={size} />,
    },
    ...monthlySalary(size),

    //Insurance
    {
      columnId: "insurance_existence_last_year",
      label: "昨年以前",
      type: "text",
      width: 120,
      icon: <MouseClickRightSvg size={size} />,
    },
    ...monthlyInsurance(size),

    //Adjusting
    {
      columnId: "num_children_last_year",
      label: "昨年以前",
      type: "text",
      width: 120,
      icon: <MouseClickRightSvg size={size} />,
    },
    ...monthlyNum(size),

    //TaxAmount
    {
      columnId: "inhabitant_tax_type", // 1. 普通徴収 - tax_normal (default), 2. 特別徴収 - tax_special
      label: "住民税の種別",
      type: "text",
      width: 160,
      icon: <MouseClickRightSvg size={size} />,
    },
    {
      columnId: "inhabitant_tax_last_year",
      label: "昨年以前",
      type: "numberCurrency",
      width: 120,
      icon: <></>,
    },
    ...monthlyInhabitant,

    {
      columnId: "total",
      label: "年間",
      type: "numberCurrency",
      width: 120,
      icon: <></>,
    },
  ];
};

export const isEmptyNumChildrenValue = (cellValue: string | null | undefined) =>
  !cellValue || !String(cellValue).trim();

export const buildWorkerJoinDateMap = (workers: Worker[] = []) =>
  new Map(
    workers
      .filter((worker) => worker?.id != null && worker?.join_date)
      .map((worker) => [Number(worker.id), worker.join_date]),
  );

export const resolveWorkerJoinDate = (
  record: {
    join_date?: string | null;
    worker?: { join_date?: string | null };
    workerId?: number;
    worker_id?: number;
  },
  joinDateByWorkerId?: Map<number, string>,
) =>
  record.join_date ||
  record.worker?.join_date ||
  joinDateByWorkerId?.get(Number(record.workerId ?? record.worker_id)) ||
  null;

const hasSheetValue = (value: unknown) =>
  value !== null &&
  value !== undefined &&
  !(typeof value === "string" && value.trim() === "");

const inferRequiredNumChildrenStartMonth = (
  record: Record<string, unknown>,
) => {
  const monthlyFieldPrefixes = [
    "salary_",
    "insurance_existence_last_",
    "num_children_",
    "inhabitant_tax_",
  ];

  return MONTHLY.find((month) =>
    monthlyFieldPrefixes.some((prefix) =>
      hasSheetValue(record[`${prefix}${month}_month`]),
    ),
  );
};

export const isNumChildrenColumn = (columnId: string) =>
  columnId === "num_children_last_year" ||
  /^num_children_\d+_month$/.test(columnId);

export const getNumChildrenColumnYearMonth = (
  columnId: string,
  yearCycle: number,
): { year: number; month: number } | null => {
  if (columnId === "num_children_last_year") {
    return null;
  }

  const match = columnId.match(/^num_children_(\d+)_month$/);
  if (!match) {
    return null;
  }

  const month = Number(match[1]);
  if (month === 12) {
    return { year: yearCycle - 1, month: 12 };
  }

  return { year: yearCycle, month };
};

export const shouldHighlightEmptyNumChildren = (
  columnId: string,
  cellValue: string | null | undefined,
  record: {
    join_date?: string | null;
    worker?: { join_date?: string | null };
    workerId?: number;
    worker_id?: number;
  } & Record<string, unknown>,
  yearCycle: number,
  joinDateByWorkerId?: Map<number, string>,
) => {
  if (
    !isNumChildrenColumn(columnId) ||
    columnId === "num_children_last_year" ||
    !isEmptyNumChildrenValue(cellValue)
  ) {
    return false;
  }

  const columnMonth = Number(columnId.match(/^num_children_(\d+)_month$/)?.[1]);
  if (!columnMonth) {
    return false;
  }

  const joinDate = resolveWorkerJoinDate(record, joinDateByWorkerId);
  if (!joinDate) {
    const inferredStartMonth = inferRequiredNumChildrenStartMonth(record);
    if (!inferredStartMonth) {
      return false;
    }

    return MONTHLY.indexOf(columnMonth) >= MONTHLY.indexOf(inferredStartMonth);
  }

  const columnYearMonth = getNumChildrenColumnYearMonth(columnId, yearCycle);
  if (!columnYearMonth) {
    return false;
  }

  const joinMoment = moment(joinDate);
  if (!joinMoment.isValid()) {
    return false;
  }

  const columnDate = moment({
    year: columnYearMonth.year,
    month: columnYearMonth.month - 1,
  });
  const joinDateMonth = moment({
    year: joinMoment.year(),
    month: joinMoment.month(),
  });

  return columnDate.isSameOrAfter(joinDateMonth, "month");
};

export const filterFields = [
  "name",
  "worker_no",
  "is_working",
  "salary_last_year",
  ...MONTHLY.map((item) => `salary_${item}_month`),
  "insurance_existence_last_year",
  ...MONTHLY.map((item) => `insurance_existence_last_${item}_month`),
  "num_children_last_year",
  ...MONTHLY.map((item) => `num_children_${item}_month`),
  "inhabitant_tax_last_year",
  ...MONTHLY.map((item) => `inhabitant_tax_${item}_month`),
  "total",
];
export const staff_tax_sheet_special_field_convert_attr = [
  "insurance_existence",
  "num_children",
  "salary",
  "inhabitant_tax_type",
  "salary_last_year",
  ...MONTHLY.map((item) => `salary_${item}_month`),
  "insurance_existence_last_year",
  ...MONTHLY.map((item) => `insurance_existence_last_${item}_month`),
  "num_children_last_year",
  ...MONTHLY.map((item) => `num_children_${item}_month`),
];
